import {DepartmentSubscription, Invoice, Product} from '@app/core/models/subscription.model';
import {Card} from '@app/core/models/card.model';
import {Pagination} from '@app/core/models/pagination.model';

export interface ISubscriptionState {
	subscriptions: DepartmentSubscription[];

	invoices: Invoice[];

	products: Product[];

	card: Card;

	isLoading: boolean;
	isInvoicesLoading: boolean;
	isLoadingSubscriptionUpdates: boolean;
	invoicesPagination: Pagination;
}

export const initialSubscriptionState: ISubscriptionState = {
	subscriptions: [],

	invoices: [],

	products: [],

	card: undefined,

	isLoading: false,
	isInvoicesLoading: false,
	isLoadingSubscriptionUpdates: false,
	invoicesPagination: null,
};
